import { FC } from "react";

import { GalleryTabData } from "@/data/types";
import { getGalleryItemKey } from "@/lib/cms";

import { GalleryTabImageItem } from "./gallery-tab-image-item";
import { GalleryTabVideoItem } from "./gallery-tab-video-item";

type GalleryItemProps = {
  item: GalleryTabData;
  itemIndex: number;
};

const GalleryItem: FC<GalleryItemProps> = ({ item, itemIndex }) => {
  if (item.type === "image") {
    return <GalleryTabImageItem item={item} itemIndex={itemIndex} />;
  } else if (item.type === "video") {
    return <GalleryTabVideoItem item={item} itemIndex={itemIndex} />;
  }

  return null;
};

type GalleryItemsProps = {
  items: GalleryTabData[];
};

export const GalleryItems: FC<GalleryItemsProps> = ({ items }) => (
  <div className="space-y-4">
    {items.map((item, index) => (
      <GalleryItem
        key={getGalleryItemKey(item) ?? index}
        item={item}
        itemIndex={index}
      />
    ))}
  </div>
);
